import { Sensor } from 'common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { YStack, XStack, Text } from 'tamagui';
import { tokens } from 'tamagui-config/src/tokens';

import { LoadingOverlay } from '../../../components/common';
import { HubLineChart } from '../../../components/common/HubLineChart';
import { useThermostatData } from '../../../hooks';

interface ThermostatContentProps {
  sensor?: Sensor;
}

export const ThermostatContent: React.FC<ThermostatContentProps> = ({ sensor }) => {
  const { t } = useTranslation();
  const { thermostatData, loading, error, todayTemperature } = useThermostatData({
    days: 7,
    sensorId: sensor?.id,
  });

  if (loading) {
    return <LoadingOverlay isVisible={true} />;
  }

  if (error || !thermostatData.length) {
    return (
      <XStack flex={1} justifyContent="center" alignItems="center">
        <Text fontSize="$6" color={tokens.color.textLight} textAlign="center">
          {error || t('air.noTemperatureData')}
        </Text>
      </XStack>
    );
  }

  return (
    <YStack>
      <Text fontFamily="$heading" fontWeight="$9.5" fontSize="$9.5" color={tokens.color.white12}>
        {`${todayTemperature ?? '--'}°F`}
      </Text>

      <HubLineChart data={thermostatData} unit={'°F'} />
    </YStack>
  );
};
